import { render } from "./_admin-show.vue?vue&type=template&id=26a8386a&lang=pug"
import script from "./_admin-show.vue?vue&type=script&lang=js"
export * from "./_admin-show.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__